module.exports = __webpack_public_path__ + "static/media/carousel9.6a2316fe.jpeg";